import type { ReactNode } from 'react';

import { ForbiddenPage } from '@/components/errors/ForbiddenPage';
import { PageLoading } from '@/components/loading/PageLoading';
import { useAppSelector } from '@/hooks/useAppSelector';

const ADMIN_SLUGS = new Set(['admin']);

type RequireAdminRouteProps = {
  children: ReactNode;
};

/**
 * Guard UI cấp **admin** (slug từ JWT / `user.role`). Không thay thế 403 từ API.
 * Đặt trong React Router (cùng pattern {@link RequireOpsRoute}), không dùng `prepareHeaders`.
 */
export function RequireAdminRoute({ children }: RequireAdminRouteProps) {
  const user = useAppSelector((s) => s.auth.user);
  const authLoading = useAppSelector((s) => s.auth.isLoading);

  if (authLoading && !user) {
    return <PageLoading />;
  }

  if (!user) {
    return <ForbiddenPage />;
  }

  const raw = String(user.roleSlug ?? user.role ?? '').trim().toLowerCase();
  if (!ADMIN_SLUGS.has(raw)) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
}
